import { forwardRef, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/16/solid';
import { CloudArrowUpIcon, PaperClipIcon } from '@heroicons/react/24/outline';

import {
  FileInput,
  type FileInputProps,
} from '@/components/form/inputs/file-input';
import { cls } from '@/utils/cls';

export type FileUploadBoxProps = {
  fileName?: string;
} & FileInputProps;

const FileUploadBox = forwardRef<HTMLInputElement, FileUploadBoxProps>(
  function (
    { fileName, disabled, className, ...props }: FileUploadBoxProps,
    ref,
  ) {
    const [isMouseDrag, setIsMouseDrag] = useState(false);
    return (
      <div className={className}>
        <FileInput
          ref={ref}
          disabled={disabled}
          {...props}
          onIsMouseDragChange={setIsMouseDrag}
          className={cls('flex h-24 flex-col items-center justify-center', {
            'opacity-70': isMouseDrag,
            'h-12': disabled,
          })}
        >
          {fileName ? (
            <>
              <PaperClipIcon className="size-4" />
              <div className="flex flex-row items-center gap-2">
                <div className="max-w-full truncate pt-0.5">{fileName}</div>
                <button
                  className="block rounded-full bg-gray-400 hover:bg-gray-500"
                  onClick={function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onChange?.(null);
                  }}
                >
                  <XMarkIcon className="size-4 text-white" />
                </button>
              </div>
            </>
          ) : (
            <>
              <CloudArrowUpIcon className="size-6" />
              <div>Upload file</div>
            </>
          )}
        </FileInput>
      </div>
    );
  },
);

FileUploadBox.displayName = 'FileUploadBox';
export { FileUploadBox };
